import { render, staticRenderFns } from "./SubcontractRequestDeliveryDetailUpload.vue?vue&type=template&id=bdf07a96&"
import script from "./SubcontractRequestDeliveryDetailUpload.vue?vue&type=script&lang=js&"
export * from "./SubcontractRequestDeliveryDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports